import { render, staticRenderFns } from "./BusinessAnnualReturnsTaskQueue.vue?vue&type=template&id=29aa1afb&scoped=true&"
import script from "./BusinessAnnualReturnsTaskQueue.vue?vue&type=script&lang=js&"
export * from "./BusinessAnnualReturnsTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAnnualReturnsTaskQueue.vue?vue&type=style&index=0&id=29aa1afb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa1afb",
  null
  
)

export default component.exports